import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-especialidades-servicios',
  standalone: true,
  imports: [],
  templateUrl: './especialidades-servicios.component.html',
  styleUrl: './especialidades-servicios.component.css'
})
export class EspecialidadesServiciosComponent implements OnInit{
  constructor(
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.route.paramMap.subscribe(params=>{
      const cod_serv_procedimiento = params.get('cod_servicio_procedimiento');
      // console.log(cod_serv_procedimiento);
    })

  }

}
